($ => {
	let calendar;
	let calendarEl;
	const events = [];

	function gatherEvents() {
		const notPrinted = [];
		$('#calendarSource div').each((i, el) => {
			const {
				url,
				title,
				start,
				end,
				color,
				allDay,
				id,
				multiple,
				multipleOccurenceId,
				printedDay,
				printedMonth,
				startDay,
				endDay,
				startMonth,
				endMonth,
				startTime,
				endTime,
				startYear,
				endYear,
			} = el.dataset;
			const classNames = [];
			if(multiple === 'true') {
				classNames.push('multiple');
			}
			if(multipleOccurenceId) {
				classNames.push(`multiple-${multipleOccurenceId}`);
			}
			const isAlreadyPrintedAndFollow = events.filter((event) => event.id === id && Number(event.custom.printedDay) + 1 === Number(printedDay))[0];
			const isAlreadyNotPrintedAndFollow = notPrinted.filter((event) => event.id === id && Number(event.custom.printedDay) + 1 === Number(printedDay))[0];
			const hasADateDifferentFromStart = printedDay !== startDay || printedMonth !== startMonth;
			const hasADateDifferentFromEnd = printedDay !== endDay;
			const isStartingInAnotherMonthFutur = Number(printedMonth) < Number(startMonth);
			
			const event = {
				url,
				title,
				start,
				end,
				id,
				backgroundColor: color,
				textColor: color,
				allDay: allDay === 'true',
				classNames,
				custom: {
					printedDay,
					printedMonth,
					startDay,
					endDay,
					startMonth,
					endMonth,
					startTime,
					endTime,
					startYear,
					endYear,
				}
			};
						
			if(isAlreadyPrintedAndFollow || isAlreadyNotPrintedAndFollow || isStartingInAnotherMonthFutur) {
				const indexOfTheOnePrinted = events.findIndex((e) => e.id === id);
				if(indexOfTheOnePrinted !== -1){
					events[indexOfTheOnePrinted].end = end;
					events[indexOfTheOnePrinted].start = start;
				}
				notPrinted.push(event);
			} else {		
				if(hasADateDifferentFromStart) {
					event.start = `${startYear}-${printedMonth}-${printedDay}T${startTime}`;
				}
				if(hasADateDifferentFromEnd) {
					event.end = `${startYear}-${printedMonth}-${printedDay}T${endTime}`;
				}				
				events.push(event);
			}
		});
	}

	function getLang() {
		return $('html').attr('lang');
	}

	function getUrlVars() {
		let vars = {};
        window.location.pathname.split('/').forEach(v => {
            if (v !== '') {
                const pair = v.split('-');
                vars[pair[0]] = pair[1];
            }
        });
		return vars;
	}

	function getDate() {
		const d = new Date();
        const urlvars = getUrlVars();
		const month = urlvars.month || d.getMonth();
		const year = urlvars.year || d.getFullYear();
		return new Date(year, month, 1);
	}

	function runCalendar() {
		calendar = new FullCalendar.Calendar(calendarEl.get(0), {
			plugins: ['dayGrid'],
			header: false,
			columnHeaderFormat: { weekday: 'long' },
			events,
			height: "auto",
			aspectRatio: 2,
			locale: getLang(),
			defaultDate: getDate(),
		});
		calendar.render();
	}

	function aspectRatio(isSm){
		if(isSm) {
			calendar.setOption('aspectRatio', 1.16);
		} else {
			calendar.setOption('aspectRatio', 1.16);
		}
	}

	function responsiveCheck() {
		// on init check
		let wWidth = $(window).width();
		let isSm = wWidth < 1024;
		aspectRatio(isSm);
		// on resize check
		$(window).resize(() => {
			wWidth = $(window).width();
			isSm = wWidth < 1024;
			aspectRatio(isSm);
		});
	}
	
	function toggleCalendarTrue() {
		const today = $('[data-id=todayCalendar]');
		const prev = $('[data-id=prevCalendar]');
		const next = $('[data-id=nextCalendar]');
		[today, prev, next].map((el) => {
			const $el = $(el);
			const href = $el.attr('href');
			const haveCalendarTrue = href.search('calendar-true') !== -1;
			if(haveCalendarTrue) {
				const newUrl = href.replace('calendar-true', 'calendar-false');
				$el.attr('href', newUrl);
			} else {
				let modUrl = href.replace('/calendar-false', '');
				modUrl = href.replace('calendar-false', '');
				let newUrl = modUrl.split('?');
				newUrl = newUrl.length === 1 ? `${newUrl[0]}/calendar-true` : `${newUrl[0]}/calendar-true/${newUrl[1]}`;
				newUrl = newUrl.replace('//', '/');
				newUrl = newUrl.substring(newUrl.length - 1) === '/' ? newUrl.substring(0, newUrl.length - 1) : newUrl;
				$el.attr('href', newUrl);
			}
		});
		$('#calendarToggler').val($('#calendarToggler').val() !== 'true');
	}

	function toggleCalendarInput(showCalendar) {
		$('form.events-filter').each((i, el) => {
			let $calInput = $('input[name="calendar"]', el);
			if (showCalendar) {
				if ($calInput.length) {
					$calInput.val(true);
				} else {
					let input = document.createElement('input');
					input.name = "calendar";
					input.type = "hidden";
					input.value = "true";
					el.appendChild(input);
				}
			} else {
				if ($calInput) {
					$calInput.remove();
				}
			}
		});
	}

	function closeFilter() {
		let $activeTargets = $('.events-filter_active');
		$activeTargets.each((i, el) => {
			let $activeTarget = $(el);
			$activeTarget.removeClass('events-filter_active');
			$activeTarget.slideUp(250);
		});
	}

	function applyFilters() {
		var btn = $(this);
		var filtersCtn = btn.closest('.js-filters-ctn');
		var newUrl = filtersCtn.attr('data-url');

		filtersCtn.find('select, input').each(function() {
			if ($(this).val() && $(this).val() !== '') {
				newUrl += '/' + $(this).attr('name') + '-' + $(this).val();
			}
		});

		window.location.href = newUrl;
	}

	function init() {
        calendarEl = $('#calendar');
		if(calendarEl.length > 0) {
			gatherEvents();
			runCalendar();
			responsiveCheck();
		}
		$('[data-id=showCalendar]').click(({currentTarget}) => {
			const context = $(currentTarget).closest('.calendar');
			context.addClass('calendar_active');
			calendarEl.slideDown();
			calendar.setOption('aspectRatio', 1.35);
			toggleCalendarTrue();
			toggleCalendarInput(true);
			$('.calendar__content-filter', context).slideDown();
			$('.events-filter:not(.events-filter_calendar)').slideUp();
		});
		$('[data-id=hideCalendar]').click(({currentTarget}) => {
			const context = $(currentTarget).closest('.calendar');
			context.removeClass('calendar_active');
			calendarEl.slideUp();
			toggleCalendarTrue();
			toggleCalendarInput(false);
			$('.calendar__content-filter', context).slideUp();
			$('.events-filter:not(.events-filter_calendar)').slideDown();
		});
		$('[data-id="filter"]').click(({currentTarget}) => {
			const $context = $(currentTarget).closest('.calendar').length > 0 ? $(currentTarget).closest('.calendar') : $(currentTarget).closest('.admin-wrapper');
			const $btns = $context.find('[data-id="filter"]');
			const $filters = $context.find('.events-filter');
			if ($filters.hasClass('events-filter_active')) {
				closeFilter();
			} else {
				$filters.addClass('events-filter_active');
				$filters.slideDown(250);
			}
		});
		$('.calendar-date-picker__action').click(({currentTarget}) => {
			const context = $(currentTarget).parent();
			const dropdown = $('.calendar-date-picker__dropdown', context);
			dropdown.slideToggle(250, 'swing');
			context.toggleClass('calendar-date-picker_active');
		});
		$('.fc-event').mouseenter(({currentTarget})=> {
			const value = currentTarget.className;
			const match = value.match(/multiple-\d{1,}/g);
			if (match ? match.length > 0 : false) {
				const matchingClass = match[0];
				$(`.fc-event.${matchingClass}`).addClass('active');
			}
		});
		$('.fc-event').mouseleave(({currentTarget})=> {
			const value = currentTarget.className;
			const match = value.match(/multiple-\d{1,}/g);
			if (match ? match.length > 0 : false) {
				const matchingClass = match[0];
				$(`.fc-event.${matchingClass}`).removeClass('active');
			}
		});
		$(document).on('click', ({target}) => {
			if (!$(target).is('[data-id="filter"]') && !$(target).is('.events-filter_active') && $(target).closest('.events-filter_active').length === 0) {
				closeFilter();
			}
		});

		$('.js-apply-calendar-filters-btn').click(applyFilters);
	}
	$(init);
})(jQuery);